var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "el-select indiction-select tag-no-wrap",
      class: { "tag-focus": _vm.selectHoverFocus },
      staticStyle: { width: "100%" },
      on: {
        click: _vm.openDialog,
        mouseenter: function ($event) {
          _vm.inputHovering = true
        },
        mouseleave: function ($event) {
          _vm.inputHovering = false
        },
      },
    },
    [
      _vm.multiple
        ? _c(
            "div",
            {
              ref: "tags",
              staticClass: "el-select__tags",
              staticStyle: { width: "calc(100% - 35px)" },
            },
            [
              _vm.collapseTags && _vm.selectedValue.length > 1
                ? _c(
                    "span",
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: _vm.collapseTagSize,
                            type: "info",
                            closable: "",
                            "disable-transitions": "",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.deleteTag(
                                $event,
                                _vm.selectedValue[0],
                                0
                              )
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "el-select__tags-text" }, [
                            _vm._v(_vm._s(_vm.selectedValue[0].text)),
                          ]),
                        ]
                      ),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            slot: "reference",
                            closable: false,
                            size: _vm.collapseTagSize,
                            type: "info",
                            "disable-transitions": "",
                          },
                          nativeOn: {
                            mouseenter: function ($event) {
                              return _vm.collapseTagMouseenter.apply(
                                null,
                                arguments
                              )
                            },
                          },
                          slot: "reference",
                        },
                        [
                          _c("span", { staticClass: "el-select__tags-text" }, [
                            _vm._v("+ " + _vm._s(_vm.selectedValue.length - 1)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _c(
                    "transition-group",
                    { on: { "after-leave": _vm.resetInputHeight } },
                    _vm._l(_vm.selectedValue, function (item, i) {
                      return _c(
                        "el-tag",
                        {
                          key: item.value,
                          attrs: {
                            size: _vm.collapseTagSize,
                            type: "info",
                            closable: "",
                            "disable-transitions": "",
                          },
                          on: {
                            close: function ($event) {
                              return _vm.deleteTag($event, item, i)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "el-select__tags-text" }, [
                            _vm._v(_vm._s(item.text)),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-input",
        {
          ref: "reference",
          class: { "is-focus": _vm.visible },
          attrs: {
            value: _vm.selectedValue.text,
            "validate-event": false,
            tabindex: _vm.multiple ? "-1" : null,
            placeholder: _vm.values.length > 0 ? "" : "请选择",
            type: "text",
            readonly: "",
          },
        },
        [
          _vm.$slots.prefix
            ? _c("template", { slot: "prefix" }, [_vm._t("prefix")], 2)
            : _vm._e(),
          _c("template", { slot: "suffix" }, [
            _vm.showCloseCopy
              ? _c("i", {
                  staticClass:
                    "el-select__caret el-input__icon el-icon-circle-close is-reverse",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleClearClick.apply(null, arguments)
                    },
                  },
                })
              : _c("i", {
                  staticClass:
                    "el-select__caret el-input__icon el-icon-search is-reverse",
                }),
          ]),
        ],
        2
      ),
      !_vm.isDesign
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.selectedValue.length > 1,
                  expression: "selectedValue.length > 1",
                },
              ],
              ref: "selectHover",
              staticClass: "indiction-select-hover",
              style: _vm.selectHoverStyle,
              attrs: { tabindex: "0", hidefocus: "true" },
              on: {
                focus: function ($event) {
                  _vm.selectHoverFocus = true
                },
                blur: function ($event) {
                  _vm.selectHoverFocus = false
                },
              },
            },
            _vm._l(_vm.selectedValue, function (item, i) {
              return _c(
                "el-tag",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: i,
                      expression: "i",
                    },
                  ],
                  key: item.value,
                  attrs: {
                    type: "info",
                    size: "small",
                    closable: "",
                    "disable-transitions": "",
                  },
                  on: {
                    close: function ($event) {
                      return _vm.deleteTag($event, item, i)
                    },
                  },
                  nativeOn: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.$selectHover.focus()
                    },
                  },
                },
                [
                  _c("span", { staticClass: "el-select__tags-text" }, [
                    _vm._v(_vm._s(item.text)),
                  ]),
                ]
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }